import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Google OAuth callback drops the JWT in the URL fragment
    // (window.location.hash) so it never appears in server logs.
    if (window.location.hash.includes('access_token=')) {
      const params = new URLSearchParams(window.location.hash.slice(1));
      const tok = params.get('access_token');
      if (tok) {
        localStorage.setItem('reachly_token', tok);
        // Strip the fragment so a refresh doesn't re-run this branch.
        window.history.replaceState({}, '', window.location.pathname + window.location.search);
      }
    }
    const token = localStorage.getItem('reachly_token');
    if (!token) { setLoading(false); return; }
    api.get('/auth/me')
      .then(async r => {
        setUser(r.data.user);
        // Keep the server's stored timezone in sync with the browser so
        // per-step scheduling windows are interpreted in the user's zone.
        try {
          const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (browserTz && browserTz !== r.data.user.timezone) {
            const upd = await api.patch('/users/me', { timezone: browserTz });
            setUser(upd.data.user);
          }
        } catch (err) { console.warn('Timezone sync skipped:', err); }
      })
      .catch((err)=>{ console.warn('Auth check failed:', err); }).finally(()=>setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('reachly_token', r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };
  const signup = async (name, email, password) => {
    const r = await api.post('/auth/signup', { name, email, password });
    localStorage.setItem('reachly_token', r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => { localStorage.removeItem('reachly_token'); setUser(null); };
  const refresh = async () => { const r = await api.get('/auth/me'); setUser(r.data.user); return r.data.user; };

  return <AuthCtx.Provider value={{ user, loading, login, signup, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export function useAuth() { return useContext(AuthCtx); }

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0a0a0b] flex items-center justify-center text-zinc-500">Loading…</div>;
  if (!user) { window.location.href = '/login'; return null; }
  return children;
}
